import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollGetEmployeeVpfResponse } from './types';

export const getEmployeeVpfDataQuery = gql`
  query PayrollGetEmployeeVpf($peopleId: String!) {
    payrollGetEmployeeVpf(peopleId: $peopleId) {
      data {
        peopleId
        vpfAmount
        maximumAllowedAmount
      }
      code
      success
      message
    }
  }
`;

const getEmployeeVpfData = (peopleId: string) => {
  if (peopleId) {
    return graphQLApi<PayrollGetEmployeeVpfResponse, { peopleId: string }>({
      query: getEmployeeVpfDataQuery,
      queryVariables: { peopleId },
    });
  } else {
    return Promise.reject('PeopleId is required');
  }
};

export default { getEmployeeVpfData };